module.exports = __webpack_public_path__ + "1054e0229e293dc6a9f4a280605925b3.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/header/components/images/hkspop-header-bg.jpg
 ** module id = 1390
 ** module chunks = 0
 **/